import { useMutation } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { AffiliateProgramService } from "@/services/affiliate-program.service";
import { AxiosError } from "axios";
import { AxiosErrorResponse } from "@/@types/Errors";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ApplyAffiliateProgramData {
  productId: string;
  partner_invite_code?: string;
}

export const useApplyInviteAffiliation = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation("invitationAffiliateLink");

  const { mutate, isPending: isConfiguring } = useMutation({
    mutationFn: (data: ApplyAffiliateProgramData) =>
      AffiliateProgramService.applyAffiliateProgram(data),
    onSuccess: async () => {
      localStorage.removeItem("redirectAfterEmailVerification");
      navigate("/invitation-affiliate-confirm");
    },
    onError: (error: AxiosError<AxiosErrorResponse>) => {
      toast({
        variant: "error",
        description: error?.response?.data?.message || t("error"),
      });
    },
  });

  return {
    applyInviteAffiliation: mutate,
    isConfiguring,
  };
};
